export const RESET_AUTH_STATE = 'RESET_AUTH_STATE'
export const USER_LOGGED_IN = 'AUTH_LOGGED_IN'
export const SET_ACCESS_SUBCOMPONENTS = 'SET_ACCESS_SUBCOMPONENTS'
export const SET_IS_WORKFLOW_RENDERABLE = 'SET_IS_WORKFLOW_RENDERABLE'
export const SET_IS_COOKIE_ENABLED = 'SET_IS_COOKIE_ENABLED'
